/**
 * GuardaModuloCrm — rota de layout que só deixa entrar nas telas /tarefas/* quando
 * o CRM está LIGADO no portal de acesso (servicoshabilitados/{portal}.servicos.crm).
 * Desligado → /modulo-indisponivel, como os Certificados de Faixas Coloridas.
 *
 * Uso em routes/AppRouter.jsx, envolvendo as rotas LOCAIS do CRM:
 *
 *     <Route element={<GuardaModuloCrm />}> …rotas /tarefas/*… </Route>
 *
 * Como rota de layout ela fica MONTADA enquanto a pessoa navega entre telas do
 * CRM — uma leitura só, não uma por troca de tela.
 *
 * Sem usuário (ou o AuthContext ainda carregando) ela não decide nada: deixa o
 * ProtectedRoute de cada rota mandar para o login. A leitura do servicoshabilitados
 * exige login; decidir "desligado" com ela negada mandaria quem só não entrou
 * ainda para a página de módulo indisponível.
 *
 * Enquanto lê, mostra o mesmo spinner do ProtectedRoute — nada da casca do CRM
 * aparece e some (sem "piscar" a tela para quem vai ser redirecionado).
 */
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { useModuloCrm } from '../../hooks/useModuloCrm';

export default function GuardaModuloCrm({ children }) {
  const { currentUser, loading } = useAuth() || {};
  const { carregando, ativo } = useModuloCrm();
  const location = useLocation();
  const conteudo = children ?? <Outlet />;

  if (loading || !currentUser) return conteudo;

  if (carregando) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" data-testid="crm-verificando-modulo">
        <CircularProgress />
      </Box>
    );
  }

  if (!ativo) {
    return <Navigate to="/modulo-indisponivel" replace state={{ modulo: 'crm', from: location }} />;
  }

  return conteudo;
}
